export default __webpack_public_path__ + "img/d22256da4196cfa424f207f53fdfc7eb.png";